const DASHBOARD_ENTRY_PATHS = new Set(["/", "/dashboard"]);
const debugPrefetch = import.meta.env.DEV;

const appPrefetchers = [
  () => import("pages/company"),
  () => import("pages/settings"),
  () => import("pages/support"),
];

type IdleWindow = Window & {
  requestIdleCallback?: (
    callback: IdleRequestCallback,
    options?: IdleRequestOptions,
  ) => number;
};

const runPrefetchQueue = (prefetchers: Array<() => Promise<unknown>>) => {
  prefetchers.forEach((prefetch, index) => {
    window.setTimeout(() => {
      prefetch().catch(() => {
        if (debugPrefetch) {
          // eslint-disable-next-line no-console
          console.debug("Route prefetch failed; loading will fall back to on-demand import.");
        }
      });
    }, index * 1500);
  });
};

export const prefetchCriticalRoutes = () => {
  const path = window.location.pathname;
  const prefetchers =
    DASHBOARD_ENTRY_PATHS.has(path) || path.startsWith("/dashboard")
      ? appPrefetchers
      : [];

  if (!prefetchers.length) return;

  const idleWindow = window as IdleWindow;
  const schedulePrefetch = () => runPrefetchQueue(prefetchers);

  if (idleWindow.requestIdleCallback) {
    idleWindow.requestIdleCallback(schedulePrefetch, { timeout: 3000 });
    return;
  }

  window.setTimeout(schedulePrefetch, 2000);
};
